import instance from "../../config/axios";

export async function submitData(id: number | undefined, data: any) {
    const url = id ? `/feedback/${id}` : `/feedback`
    const response = await instance({ url, method: id? "PUT" : "POST", data: data });
    return response.data;
}
  